import React from 'react';

import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Button, Form, Input } from 'antd';

import IntlMessages from 'util/IntlMessages';
import BoxContainer from 'components/BoxContainer';
import { KeyValueWidget } from 'components/KeyValueWidget';
import Title from 'components/BoxContainer/components/Title';
import { REMOTE_CONFIG_KEYS, useRemoteConfigAccess } from 'packages/utils';
import useCloudFunction from 'packages/utils/hooks/clouds/useCloudFunction';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import Card from '../components/Card';
import { AUTH_DT_ROUTES } from '../../constants';

export const SignInDt = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const intl = useIntl();
  const { mutateAsync: checkEmailDt, loading } = useCloudFunction({
    op: API_OPERATIONS.MAIL_VALIDATION_DT,
    runFirstTime: false,
  });
  const { value: timeTrackerRM } = useRemoteConfigAccess(REMOTE_CONFIG_KEYS.TIME_TRACKER);

  const emailRules = [
    {
      key: 'required',
      required: true,
      message: intl.formatMessage({ id: 'form.required.msg' }),
    },
    {
      key: 'format',
      type: 'email',
      message: intl.formatMessage({ id: 'form.format.msg' }),
    }
  ].filter(e => timeTrackerRM?.allowAnyDomain === true && e.key !== 'domain');

  const onSubmit = async values => {
    try {
      const { data, error } = await checkEmailDt({ email: values.email });
      if (error || data?.code === 'permission-denied') throw data?.code;

      if (data.message === 'success') {
        history.push(AUTH_DT_ROUTES.ENTER_PASSWORD, {
          email: values.email,
        });
      }
      return;
    } catch (error) {
      const message = {
        'permission-denied': intl.formatMessage({ id: 'work.direction.auth.signin.email.error' }),
        default: intl.formatMessage({ id: 'general.email.error' }),
      };
      form.setFields([
        {
          name: 'email',
          errors: [message[error || 'default']],
        },
      ]);
    }
  };

  const onAlreadyCode = () => {
    const email = form.getFieldValue('email');
    if (!email) {
      form.setFields([
        {
          name: 'email',
          errors: [intl.formatMessage({ id: 'work.direction.auth.already.code.missing.email' })],
        },
      ]);
      return;
    }
    history.push(AUTH_DT_ROUTES.ENTER_PASSWORD, {
      email,
      hasCode: true,
    });
  };

  return (
    <BoxContainer>
      <BoxContainer content loading={loading}>
        <Form form={form} onFinish={onSubmit} name="signIn">
          <Card title={<IntlMessages id="work.direction.auth.title" />}>
            <KeyValueWidget
              label={<Title.LabelForm value={<IntlMessages id="work.direction.auth.email" />} />}
              value={
                <Form.Item className="gx-ml-3 gx-mr-3" required rules={emailRules} name="email">
                  <Input className="gx-mb-1 gx-mt-2" />
                </Form.Item>
              }
            />
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => (
                <Button
                  disabled={!getFieldValue('email')}
                  htmlType="submit"
                  block
                  className="gx-mt-3 gx-w-100"
                  type="primary"
                >
                  <IntlMessages id="work.direction.auth.request.password" />
                </Button>
              )}
            </Form.Item>
            <Button onClick={onAlreadyCode} block className="gx-w-100" type="default">
              <IntlMessages id="work.direction.auth.already.code" />
            </Button>
          </Card>
        </Form>
      </BoxContainer>
    </BoxContainer>
  );
};
